import React, { createContext, useContext, useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";

const CustomerAuthContext = createContext(null);
export const useCustomerAuth = () => useContext(CustomerAuthContext);
const KEY = "illam_customer_token";

export function CustomerAuthProvider({ children }) {
  const [customer, setCustomer] = useState(null);
  const [status, setStatus] = useState("checking");

  const load = async () => {
    try {
      const t = localStorage.getItem(KEY);
      if (!t) { setStatus("guest"); return; }
      const { data } = await api.get("/customer/me", { headers: { Authorization: `Bearer ${t}` } });
      setCustomer(data);
      setStatus("authed");
    } catch { localStorage.removeItem(KEY); setStatus("guest"); }
  };
  useEffect(() => { load(); }, []);

  const requestOtp = async (phone) => {
    try { const { data } = await api.post("/customer/auth/request-otp", { phone }); return { ok: true, dev_otp: data.dev_otp }; }
    catch (e) { return { ok: false, error: formatApiError(e.response?.data?.detail) }; }
  };
  const verifyOtp = async (phone, otp) => {
    try {
      const { data } = await api.post("/customer/auth/verify-otp", { phone, otp });
      localStorage.setItem(KEY, data.access_token);
      await load();
      return { ok: true, is_new: data.is_new };
    } catch (e) { return { ok: false, error: formatApiError(e.response?.data?.detail) }; }
  };
  const cApi = (method, url, body) => {
    const t = localStorage.getItem(KEY);
    return api({ method, url, data: body, headers: { Authorization: `Bearer ${t}` } });
  };
  const logout = () => { localStorage.removeItem(KEY); setCustomer(null); setStatus("guest"); window.location.href = "/portal"; };

  return (
    <CustomerAuthContext.Provider value={{ customer, status, requestOtp, verifyOtp, reload: load, cApi, logout }}>
      {children}
    </CustomerAuthContext.Provider>
  );
}
